import { useEffect, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";

// 커스텀 드롭다운(2026-07-18) — 네이티브 <select> 는 버튼만 꾸밀 수 있고 열리는 목록은
// OS 기본이라 달력(MiniDatePicker)·필터 팝오버와 톤이 안 맞았다. 같은 팝오버 문법
// (라운드+그림자, 선택 항목 체크, 바깥 클릭 닫기)으로 통일.
// options: [{ value, label }] — value "" 는 "전체"(필터 해제) 관례.
// plain: 필터가 아닌 곳(달력 헤더의 년/월 등)에서 쓰는 중립 스타일 — 값이 있어도
// 파란 활성색을 칠하지 않는다(필터에선 "걸려 있음" 표시지만 여기선 항상 값이 있으니 소음).
export default function MiniSelect({ value, options, onChange, rounded = "rounded-md", plain = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  const current = options.find((o) => o.value === value) || options[0];

  return (
    <span className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex items-center gap-1 px-2 py-1.5 text-xs font-medium ${rounded} ${
          plain
            ? "font-semibold text-ink-900 hover:bg-ink-100"
            : `border ${value ? "border-brand-300 bg-brand-50 text-brand-700" : "border-ink-200 bg-white text-ink-600 hover:bg-ink-50"}`
        }`}
      >
        {current?.label}
        <ChevronDown className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""} ${!plain && value ? "text-brand-500" : "text-ink-400"}`} />
      </button>

      {open && (
        <div className="absolute left-0 top-full z-50 mt-1.5 max-h-64 w-max min-w-full max-w-[calc(100vw-2rem)] overflow-y-auto overflow-x-hidden rounded-xl border border-ink-100 bg-white p-1 shadow-[0_8px_24px_rgba(15,23,42,0.14)]">
          {options.map((o) => {
            const active = o.value === value;
            return (
              <button
                key={o.value || "__all__"}
                type="button"
                onClick={() => { onChange(o.value); setOpen(false); }}
                className={`flex w-full items-center gap-2 rounded-lg px-2.5 py-1.5 text-left text-xs ${
                  active ? "bg-brand-50 font-medium text-brand-700" : "text-ink-600 hover:bg-ink-50"
                }`}
              >
                {/* 모바일에서 긴 라벨(모델명 등)이 화면을 밀지 않게 truncate */}
                {o.icon}
                <span className="flex-1 truncate whitespace-nowrap">{o.label}</span>
                {active && <Check className="h-3.5 w-3.5 shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </span>
  );
}
